import styled from '@emotion/styled';
import { MaxEventBodyStyles } from 'ui-components/layout/styles';

export const EventBodyContainer = styled.div`
  display: flex;
  justify-content: center;
  ${MaxEventBodyStyles};
`;
